"use client";

import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white fixed bottom-0 w-full">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <p className="text-center">&copy; {currentYear} Accountably. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
